export default function MentorIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 11 11'
        fill='currentColor'
      >
        <g clipPath='url(#clip0_2774_52636)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M0.818359 8.09038C0.818359 8.47615 0.971606 8.84612 1.24439 9.1189C1.51717 9.39168 1.88714 9.54492 2.2729 9.54492L10.0305 9.54492C10.2121 9.54492 10.3785 9.44342 10.4616 9.28193C10.5447 9.12044 10.5306 8.92605 10.425 8.77826L8.20207 5.66613L10.425 2.55401C10.5306 2.40622 10.5447 2.21183 10.4616 2.05034C10.3785 1.88885 10.2121 1.78735 10.0305 1.78735L2.2729 1.78735C1.88713 1.78735 1.51717 1.94059 1.24439 2.21337C0.971605 2.48615 0.818359 2.85612 0.818359 3.24189L0.818359 8.09038Z'
          />
        </g>
        <defs>
          <clipPath id='clip0_2774_52636'>
            <rect width='10.6667' height='10.6667' transform='translate(0.333008 0.333008)' />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
}
